import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell, StyledButtonBlack
} from "../../../styles/MyStyles";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {GetEnumMenuItems} from "../../../logic/EnumHelper";
import {GetLookupMenuItems} from "../../../logic/LookupHelper";
import {TransformDecimalFields} from "../../../logic/OrderFieldsHeleper";

const OrderEditPage = () => {
    const { clientId, orderId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [order, setOrder] = useState({
        contactId: clientId,
        createdDate: '',
        expirationDate: '',
        action: 0,
        type: 0,
        status: 0,
        cryptoAmountRequested: '',
        requestedPrice: '',
        cryptoAmountExecuted: '',
        executedPrice: '',
        sellAssetId: '',
        buyAssetId: ''
    });

    useEffect(() => {
        const fetchOrder = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (orderId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_ORDERS_URL}/single/${orderId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        setOrder(TransformDecimalFields(data.data));
                    } else {
                        console.log('Fetch order failed.');
                    }
                } else {
                    setOrder({
                        contactId: clientId,
                        createdDate: '',
                        expirationDate: '',
                        action: 0,
                        type: 0,
                        status: 0,
                        cryptoAmountRequested: '',
                        requestedPrice: '',
                        cryptoAmountExecuted: '',
                        executedPrice: '',
                        sellAssetId: '',
                        buyAssetId: ''
                    });
                    console.log(order);
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchOrder();
    }, [orderId]);

    const validateForm = () => {
        let newErrors = {};

        if (order.createdDate === '') {
            newErrors.createdDate = 'Created Date is required.';
        }
        if (order.expirationDate === '') {
            newErrors.expirationDate = 'Expiration Date is required.';
        }


        if (order.cryptoAmountRequested === '') {
            newErrors.cryptoAmountRequested = 'Crypto Amount Requested is required.';
        } else if (isNaN(order.cryptoAmountRequested)) {
            newErrors.cryptoAmountRequested = 'Crypto Amount Requested must be number.';
        }
        if (order.type === 0) {
            if (order.requestedPrice === '') {
                newErrors.requestedPrice = 'Requested Price is required.';
            } else if (isNaN(order.requestedPrice)) {
                newErrors.requestedPrice = 'Requested Price must be number.';
            }
        }

        if (order.status === 2 || order.status === 3) {
            if (order.cryptoAmountExecuted === '') {
                newErrors.cryptoAmountExecuted = 'Crypto Amount Executed is required.';
            } else if (isNaN(order.cryptoAmountExecuted)) {
                newErrors.cryptoAmountExecuted = 'Crypto Amount Executed must be number.';
            }
            if (order.executedPrice === '') {
                newErrors.executedPrice = 'Executed Price is required.';
            } else if (isNaN(order.executedPrice)) {
                newErrors.executedPrice = 'Executed Price must be number.';
            }
        }

        if (order.sellAssetId === '') {
            newErrors.sellAssetId = 'Sell Asset is required.';
        }
        if (order.buyAssetId === '') {
            newErrors.buyAssetId = 'Buy Asset is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {

        if (event.target.name === 'action') {
            order.sellAssetId = '';
            order.buyAssetId = '';
        }

        if (event.target.name === 'type' && event.target.value !== 0) {
            order.requestedPrice = '';
        }

        setOrder({
            ...order,
            [event.target.name]: event.target.value,
        });

        //setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_ORDERS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(TransformDecimalFields(order)),
                }
            );
            if (response.ok) {
                console.log('Order updated successfully.');
                handleGoBack();
            } else {
                console.log('Update order failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleDelete = async () => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_ORDERS_URL}/${orderId}`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                }
            );
            if (response.ok) {
                console.log('Order deleted successfully.');
                handleGoBack();
            } else {
                console.log('Delete order failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {orderId ? 'Edit Order' : 'Create Order'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
                {(orderId && <StyledButtonBlack variant="contained" onClick={handleDelete}>
                    Delete
                </StyledButtonBlack>)}
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Created Date</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <DatePicker
                                timezone="UTC"
                                name="createdDate"
                                label="Created Date"
                                value={dayjs(order.createdDate)}
                                maxDate={dayjs(order.expirationDate)}
                                onChange={(date) =>  {
                                    let event = {
                                        'target': {
                                            'name': 'createdDate',
                                            'value': date.toJSON()
                                        }
                                    };
                                    handleFieldChange(event);
                                }
                                }
                                fullWidth
                                size='small'
                                slotProps={{
                                    textField: {
                                        required: true,
                                    },
                                }}
                                error={!!errors.createdDate}
                                helperText={errors.createdDate}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Expiration Date</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <DatePicker
                                timezone="UTC"
                                name="expirationDate"
                                label="Expiration Date"
                                value={dayjs(order.expirationDate)}
                                minDate={dayjs(order.createdDate)}
                                onChange={(date) =>  {
                                    let event = {
                                        'target': {
                                            'name': 'expirationDate',
                                            'value': date.toJSON()
                                        }
                                    };
                                    handleFieldChange(event);
                                }
                                }
                                fullWidth
                                size='small'
                                slotProps={{
                                    textField: {
                                        required: true,
                                    },
                                }}
                                error={!!errors.expirationDate}
                                helperText={errors.expirationDate}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Action</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="action"
                                label="Action"
                                select
                                value={order.action}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.action}
                                helperText={errors.action}
                            >
                                {GetEnumMenuItems('orderAction')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Type</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="type"
                                label="Type"
                                select
                                value={order.type}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.type}
                                helperText={errors.type}
                            >
                                {GetEnumMenuItems('orderType')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Status</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="status"
                                label="Status"
                                select
                                value={order.status}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.status}
                                helperText={errors.status}
                            >
                                {GetEnumMenuItems('orderStatus')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Sell Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="sellAssetId"
                                label="Sell Asset"
                                select
                                value={order.sellAssetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.sellAssetId}
                                helperText={errors.sellAssetId}
                            >
                                {GetLookupMenuItems('asset')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Buy Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="buyAssetId"
                                label="Buy Asset"
                                select
                                value={order.buyAssetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.buyAssetId}
                                helperText={errors.buyAssetId}
                            >
                                {GetLookupMenuItems('asset')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Crypto Amount Requested</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="cryptoAmountRequested"
                                label="Crypto Amount Requested"
                                value={order.cryptoAmountRequested}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.cryptoAmountRequested}
                                helperText={errors.cryptoAmountRequested}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Requested Price</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="requestedPrice"
                                label="Requested Price"
                                value={order.requestedPrice}
                                onChange={handleFieldChange}
                                fullWidth
                                disabled={order.type !== 0}
                                required={order.type === 0}
                                error={!!errors.requestedPrice}
                                helperText={errors.requestedPrice}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Crypto Amount Executed</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="cryptoAmountExecuted"
                                label="Crypto Amount Executed"
                                value={order.cryptoAmountExecuted}
                                onChange={handleFieldChange}
                                fullWidth
                                required={order.status === 2 || order.status === 3}
                                error={!!errors.cryptoAmountExecuted}
                                helperText={errors.cryptoAmountExecuted}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Executed Price</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="executedPrice"
                                label="Executed Price"
                                value={order.executedPrice}
                                onChange={handleFieldChange}
                                fullWidth
                                required={order.status === 2 || order.status === 3}
                                error={!!errors.executedPrice}
                                helperText={errors.executedPrice}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default OrderEditPage;
